import "./App.scss";

import "./styles/_global.scss";
import Inventory from "./components/Inventory/Inventory";
import WarehouseDetails from "./components/WarehouseDetails/WarehouseDetails.jsx";
import WarehouseList from "./components/WarehouseList/WarehouseList";
import NewWarehouse from "./components/NewWarehouse/NewWarehouse";
import EditWarehouse from "./components/EditWarehouse/EditWarehouse";
import EditInventoryItem from "./components/EditInventoryItem/EditInventoryItem";
import NewInventoryItem from "./components/NewInventoryItem/NewInventoryItem";
import InventoryItemDetails from "./components/InventoryItemDetails/InventoryItemDetails";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PageHeader from "./components/PageHeader/PageHeader";
import PageFooter from "./components/PageFooter/PageFooter";

function App() {
  return (
    <div className="App">
      <Router>
        <Route path="/" component={PageHeader} />
        <Switch>
          <Route path={["/warehouse", "/"]} exact component={WarehouseList} />
          <Route path="/warehouse/details/:id" component={WarehouseDetails} />
          <Route path="/inventory" exact component={Inventory} />
          <Route path="/warehouse/new" exact component={NewWarehouse} />
          <Route path="/warehouse/edit/:id" component={EditWarehouse} />
          <Route path="/inventory/new" component={NewInventoryItem} />
          <Route path="/inventory/edit/:id" component={EditInventoryItem} />
          <Route
            path="/inventory/details/:id"
            exact
            component={InventoryItemDetails}
          />
        </Switch>

      </Router>
      <PageFooter />
    </div>
  );
}

export default App;
